import { render, staticRenderFns } from "./TablePossession.vue?vue&type=template&id=31e180ec&scoped=true&"
import script from "./TablePossession.vue?vue&type=script&lang=js&"
export * from "./TablePossession.vue?vue&type=script&lang=js&"
import style0 from "./TablePossession.vue?vue&type=style&index=0&id=31e180ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e180ec",
  null
  
)

export default component.exports